const STORE_VISUAL_TEMPLATES_PATH = "template.visual";
const VISUAL_TEMPLATE_PARSER_TYPE = "config:template:visual";
// TODO get rid of constnants that are only used in one place

export { STORE_VISUAL_TEMPLATES_PATH, VISUAL_TEMPLATE_PARSER_TYPE };
